<template>
  <layout-page is-not-scrollable hide-copyright>
    <b-tabs
      v-model="currentTab"
      class="pipeline_tabs"
      vertical
      expanded
      :animated="false"
    >
      <!--Contacting-->
      <b-tab-item value="contacting" label="Contact Not Made">
        <contacting-pipeline-desktop v-if="currentTab === 'contacting'"></contacting-pipeline-desktop>
      </b-tab-item>

      <!--Active-->
      <b-tab-item value="active" label="Active">
        <active-pipeline-desktop v-if="currentTab === 'active'"></active-pipeline-desktop>
      </b-tab-item>

      <!--Follow Up-->
      <b-tab-item header-class="last_of_section" value="followUp" label="Follow Up">
        <follow-up-pipeline-desktop v-if="currentTab === 'followUp'"></follow-up-pipeline-desktop>
      </b-tab-item>

      <!--Completed-->
      <b-tab-item value="completed" label="Completed">
        <completed-pipeline-desktop v-if="currentTab === 'completed'"></completed-pipeline-desktop>
      </b-tab-item>

      <!--Dead-->
      <b-tab-item value="dead" label="Dead">
        <dead-pipeline-desktop v-if="currentTab === 'dead'"></dead-pipeline-desktop>
      </b-tab-item>

      <!--Non Lead-->
      <b-tab-item header-class="last_of_section" value="nonLead" label="Non Lead">
        <non-lead-pipeline-desktop v-if="currentTab === 'nonLead'"></non-lead-pipeline-desktop>
      </b-tab-item>
    </b-tabs>

    <div class="pipeline_extras">
      <pipeline-views></pipeline-views>
      <button-link size="" @click="$refs.recentlyViewModal.open()">Recently Viewed Leads</button-link>

      <div v-if="showPipelineAd" class="pipeline_ad">
        <a :href="pipelineAd.link" target="_blank">
          <template v-if="pipelineAd.video_url">
            <video autoplay muted>
              <source :src="pipelineAd.video_url" type="video/mp4">
              {{ pipelineAd.alt_text }}
            </video>
          </template>

          <img
            v-else
            :src="pipelineAd.image_url"
            :alt="pipelineAd.alt_text"
          >
        </a>
      </div>
    </div>

    <modal-before-container>
      <modal-default
        ref="recentlyViewModal"
        title="Recently Viewed Leads"
      >
        <recent-leads-modal></recent-leads-modal>
      </modal-default>
    </modal-before-container>
  </layout-page>
</template>

<script>
import ContactingPipelineDesktop from "./states/contacting/ContactingPipelineDesktop";
import ActivePipelineDesktop from "./states/active/ActivePipelineDesktop";
import DeadPipelineDesktop from "./states/dead/DeadPipelineDesktop";
import NonLeadPipelineDesktop from "./states/non-lead/NonLeadPipelineDesktop";
import CompletedPipelineDesktop from "./states/completed/CompletedPipelineDesktop";
import FollowUpPipelineDesktop from "./states/follow-up/FollowUpPipelineDesktop";
import PipelineViews from "./components/PipelineViews";
import RecentLeadsModal from "../../layouts/page/components/RecentLeadsModal";

export default {
  name: "PipelinePageDesktop",
  components: {
    RecentLeadsModal,
    PipelineViews,
    FollowUpPipelineDesktop,
    CompletedPipelineDesktop,
    NonLeadPipelineDesktop,
    DeadPipelineDesktop,
    ActivePipelineDesktop,
    ContactingPipelineDesktop,
  },
  data() {
    return {
      currentTab: "active",
      pipelineAd: {
        link: process.env.MIX_PIPELINE_AD_LINK,
        video_url: process.env.MIX_PIPELINE_AD_VIDEO_URL,
        image_url: process.env.MIX_PIPELINE_AD_IMAGE_URL,
        alt_text: process.env.MIX_PIPELINE_AD_ALT_TEXT,
      }
    };
  },
  watch: {
    $route() {
      this.setTab();
    },
    currentTab: function (newTab) {
      if (newTab !== this.$route.params.tab) {
        this.$router.replace({
          params: {tab: this.currentTab},
          query: this.$route.query
        });
      }
    }
  },
  created() {
    this.setTab();
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.isLoggedIn) {
      this.$store.dispatch("activePipelineView/tearDown");
    }

    next();
  },
  computed: {
    activePipelineView() {
      return this.$store.getters["activePipelineView/activePipelineView"];
    },
    showPipelineAd() {
      return (this.pipelineAd.image_url !== 'null' && !!this.pipelineAd.image_url) || (this.pipelineAd.video_url !== 'null' && !!this.pipelineAd.video_url);
    },
  },
  methods: {
    setTab() {
      if (this.activePipelineView) {
        this.$store.dispatch("activePipelineView/setup", this.activePipelineView.id);
      }

      if (this.$route.params.tab) {
        this.currentTab = this.$route.params.tab;
      } else {
        this.$router.replace({
          params: {tab: this.currentTab},
          query: this.$route.query
        });
      }
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.record_count {
  color: $text-light;
  font-size: 80%;
}

// These position values are magic hard coded because there
// is no other way I can think of to do this
.pipeline_extras {
  position: absolute;
  top: 330px;
  left: 2rem;
  padding-top: 30px;
  border-top: 1px solid $borderDark;
}

.pipeline_ad {
  width: 180px;
  height: 300px;
  margin-top: 2rem;
  overflow: hidden;
}

::v-deep {
  .pipeline_tabs {
    min-height: 100%;
    flex-wrap: nowrap !important; // need to override buefy

    &.b-tabs {
      height: 100%;
    }

    > .tabs {
      height: 100%;
      min-width: 170px;
      margin: 0 2rem;
      padding-top: $pagePaddingVertical;
    }


    > .tabs ul li {
      flex-grow: 0;
      margin-bottom: 20px;
      font-size: 0.875rem;
      font-weight: bold;

      &.last_of_section {
        margin-bottom: 40px;
      }

      &.is-disabled {
        pointer-events: all;
        cursor: auto;
        opacity: 1;
      }

      a {
        justify-content: space-between;
        padding: 4px 0;
        border-bottom: 2px solid transparent;
        font-size: 1.125rem;
        font-weight: bold;
      }

      &.is-active a {
        color: $primary;
        border-color: $primary;
      }
    }

    .tab-content {
      overflow: hidden !important;

      .tab-item {
        height: 100%;
      }
    }
  }
}
</style>
